<div class="absolute" style="left: 25%; right: 25%;">
   @if(error) {
    <p-message [severity]="error.severity" [text]="error.text"/>
  }
</div>

<div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">

  <div class="flex flex-column align-items-center justify-content-center">
    <div class="custom-login-card">
      <div class="w-full surface-card py-8 px-5 sm:px-8" style="border-radius:53px">
        <div class="w-20rem login-button">
          <div class="mb-5 flex justify-content-center">
            <div class="inline-block custom-logo">
              <img src="./assets/icons/favicon.svg" height="50px" width="50px" alt="" />
            </div>

          </div>
          <div class="grid flex flex-column align-items-center mb-5 login-header-container">
            <span class="text-900 text-2xl lg:text-3xl font-bold mb-3 text-center transition-colors duration-300 login-title">
              <span class="text-primary text-900 text-2xl">Je suis</span> <span class="text-2xl" style="color: #0056d2"> / </span><span class="text-2xl" style="color : #CD47E4">I am</span>
            </span>
            <div class="w-full sm:w-10 md:w-8 lg:w-6 mx-auto border-bottom-2 border-primary"></div>
          </div>
            @if(env != 'rec1' && env != 'prod' && env != 'rec2' ) {
              <p-button (click)="login('sso')" iconPos="left" label="TEST SSO" icon="pi pi-user" styleClass="custom-button"></p-button>
              <div class="h-2rem"></div>
              <p-button (click)="login('operator')" label="OPERATEUR / OPERATOR" icon="pi pi-user" iconPos="left"
              styleClass="custom-button"></p-button>
              <div class="h-2rem"></div>
              <p-button (click)="login('operator_admin')" iconPos="left" label="OPERATEUR ADMIN / ADMIN OPERATOR" icon="pi pi-user-edit"
              styleClass="custom-button"></p-button>
            }@else {
              <p-button (click)="login('sso')" iconPos="left" label="OPERATEUR / OPERATOR" icon="pi pi-user" styleClass="custom-button"></p-button>
            }     
          <div class="h-2rem"></div> 
          <p-button (click)="login('seller')" iconPos="left" label="VENDEUR / SELLER" icon="pi pi-shop"
            styleClass="custom-button"></p-button>
        </div>

      </div>
    </div>
  </div>
</div>

